import { createFileRoute } from '@tanstack/react-router';
import VerifyEmailPage from '../Containers/VerifyEmailPage';

export const Route = createFileRoute('/register_/email')({
  component: VerifyEmailPage,
});
